define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/core/ExtendedPath",
	"csi/locale",
	"csi/prefs",
	"csi/prefs/BrowseAttributesStore",
	"csi/reflection",
	"csi/xml",
	"Apparel/QueryFilterController"
], function(array, declare, ExtendedPath, locale, prefs, BrowseAttributesStore, reflection, xml, QueryFilterController) {

	return declare(QueryFilterController, {
		/**
		 * @override
		 * Takes ProductType enum, removes first part (ProductType:) and last 4 characters (Type)
		 * to get Material or Style as a result
		 */
		onStart: function() {
			var node = this.getNode();
			var enumStr = node.PlacementProductType;
			enumStr = xml.enumGetText(enumStr);
			this.queryFilterStartType = enumStr;
			this.queryFilterType = enumStr;
		},
	});
});